/**
 * Builds an environment-aware URL. On QA: `{url}{branch}/{suffix}`, on prod: `{url}{suffix}`.
 *
 * @param {string} url - Base URL path
 * @param {Object} [options]
 * @param {string} [options.branch='__latest'] - QA-only branch inserted after the base path
 * @param {string} [options.suffix=''] - Extra path appended in every environment
 * @returns {string}
 */
export const getEnvironment = function (url) {
  let {
    branch = '__latest',
    suffix = ''
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (typeof window !== 'undefined' && window.location) {
    return window.location.hostname.includes('frontend-qa-1.auto1-test.com') ? `${url}${branch}/${suffix}` : `${url}${suffix}`;
  }
  return `${url}${suffix}`;
};